import {Injectable} from '@angular/core';
import {Cookie} from '../../utilities/cookie';
import {Session} from '../../utilities/session';
import {CUSTOM_CONSTANTS} from '../../utilities/config';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor() {
  }

  public isTokenLogged(): boolean {
    return !!this.getAuthUserToken();
  }

  public setAuthUser(user) {
    // let set token for the user
    Cookie.set(CUSTOM_CONSTANTS.APP_VARIABLE, user, {
      expires: 1
    });
    // let set uer session
    Session.set(CUSTOM_CONSTANTS.APP_VARIABLE, user);
  }

  /**
   * getAuthUser
   * @returns {any}
   */
  public getAuthUser(): any {
    return Session.get(CUSTOM_CONSTANTS.APP_VARIABLE);
  }

  /**
   *
   * @return {any}
   */
  public getAuthUserToken(): any {
    return Cookie.getToken() && Cookie.getToken().accessToken;
  }

  /**
   *
   */
  private removeAuthUser(): void {
    Cookie.remove(CUSTOM_CONSTANTS.APP_VARIABLE);
    Session.remove(CUSTOM_CONSTANTS.APP_VARIABLE);
  }

  /**
   *
   */
  public logoutToken(url = null): void {
    console.log('URL ', url);
    this.removeAuthUser();
    const storedUrl = localStorage.getItem('VIEW_DOCUMENT');
    Session.clear();
    localStorage.clear();
    if(storedUrl) {
      localStorage.setItem('VIEW_DOCUMENT', storedUrl);
    }
  }
}
